var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-wrapper"},[_c('video',{ref:"player",staticClass:"player",attrs:{"controls":_vm.playing,"src":_vm.videoSrc,"poster":_vm.posterSrc}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.playing),expression:"!playing"}],staticClass:"play-icon icomoon-triangle",on:{"click":_vm.handlePlayIconClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }